/**
 * Reference-counted body scroll lock. Every modal or full-screen shell takes a lock and gives it back; the page
 * scrolls again only when the last one is released, whatever order they close in (two stacked modals used to leave
 * the body at overflow: hidden for good).
 */
let holders = 0;
let saved = "";

export function lockBodyScroll(): () => void {
  if (holders === 0) {
    saved = document.body.style.overflow;
    document.body.style.overflow = "hidden";
  }
  holders += 1;
  let released = false;
  return () => {
    if (released) return;
    released = true;
    holders -= 1;
    if (holders === 0) document.body.style.overflow = saved;
  };
}
